import { render, staticRenderFns } from "./CustomerBonusesPoints.vue?vue&type=template&id=ee7605c0&scoped=true&"
import script from "./CustomerBonusesPoints.vue?vue&type=script&lang=js&"
export * from "./CustomerBonusesPoints.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBonusesPoints.vue?vue&type=style&index=0&id=ee7605c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7605c0",
  null
  
)

export default component.exports